/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件工具自动生成，请勿直接修改！！！ */

// @ts-ignore

import request from '@/utils/request/index';
/**
 * 接口 [创建智能体↗](https://yapi.fenxianglife.com/project/379/interface/api/47629) 的 **请求函数**
 *
 * @分类 [群运营↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10866)
 * @请求头 `POST /community/createBot`
 * @更新时间 `2024-01-31 13:43:50`
 */
export const feimaChatCommunityCreateBot = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCommunityCreateBotRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatCommunityCreateBotResponse, OT>
  >('/community/createBot', 'POST', data, options);

/**
 * 接口 [采集号\/跟单号添加群↗](https://yapi.fenxianglife.com/project/379/interface/api/47632) 的 **请求函数**
 *
 * @分类 [群运营↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10866)
 * @请求头 `POST /community/addBotRePostGroup`
 * @更新时间 `2024-01-31 14:29:20`
 */
export const feimaChatCommunityAddBotRePostGroup = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCommunityAddBotRePostGroupRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatCommunityAddBotRePostGroupResponse,
      OT
    >
  >('/community/addBotRePostGroup', 'POST', data, options);

/**
 * 接口 [获取采集号↗](https://yapi.fenxianglife.com/project/379/interface/api/47635) 的 **请求函数**
 *
 * @分类 [群运营↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10866)
 * @请求头 `GET /community/getCollectBot`
 * @更新时间 `2024-02-01 16:07:48`
 */
export const feimaChatCommunityGetCollectBot = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatCommunityGetCollectBotRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatCommunityGetCollectBotResponse, OT>
  >('/community/getCollectBot', 'GET', data, options);

/**
 * 接口 [跟单号列表↗](https://yapi.fenxianglife.com/project/379/interface/api/47638) 的 **请求函数**
 *
 * @分类 [群运营↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10866)
 * @请求头 `POST /community/getFollowBotList`
 * @更新时间 `2024-02-01 16:09:40`
 */
export const feimaChatCommunityGetFollowBotList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCommunityGetFollowBotListRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatCommunityGetFollowBotListResponse,
      OT
    >
  >('/community/getFollowBotList', 'POST', data, options);

/**
 * 接口 [采集号\/跟单号删除群↗](https://yapi.fenxianglife.com/project/379/interface/api/47647) 的 **请求函数**
 *
 * @分类 [群运营↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10866)
 * @请求头 `POST /community/delBotRePostGroup`
 * @更新时间 `2024-01-31 16:05:31`
 */
export const feimaChatCommunityDelBotRePostGroup = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCommunityDelBotRePostGroupRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatCommunityDelBotRePostGroupResponse,
      OT
    >
  >('/community/delBotRePostGroup', 'POST', data, options);

/**
 * 接口 [群运营智能体微信群列表↗](https://yapi.fenxianglife.com/project/379/interface/api/47650) 的 **请求函数**
 *
 * @分类 [群运营↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10866)
 * @请求头 `POST /community/wxGroupList`
 * @更新时间 `2024-04-17 17:21:13`
 */
export const feimaChatCommunityWxGroupList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCommunityWxGroupListRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatCommunityWxGroupListResponse, OT>
  >('/community/wxGroupList', 'POST', data, options);

/**
 * 接口 [群列表↗](https://yapi.fenxianglife.com/project/379/interface/api/47794) 的 **请求函数**
 *
 * @分类 [群运营↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10866)
 * @请求头 `POST /wxGroup/list`
 * @更新时间 `2024-04-24 19:59:54`
 */
export const feimaChatWxGroupList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxGroupListRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatWxGroupListResponse, OT>>(
    '/wxGroup/list',
    'POST',
    data,
    options
  );

/**
 * 接口 [修改群名称↗](https://yapi.fenxianglife.com/project/379/interface/api/47797) 的 **请求函数**
 *
 * @分类 [群运营↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10866)
 * @请求头 `POST /wxGroup/modifyGroupName`
 * @更新时间 `2024-02-28 15:39:49`
 */
export const feimaChatWxGroupModifyGroupName = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxGroupModifyGroupNameRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatWxGroupModifyGroupNameResponse, OT>
  >('/wxGroup/modifyGroupName', 'POST', data, options);

/**
 * 接口 [群聊置顶↗](https://yapi.fenxianglife.com/project/379/interface/api/47800) 的 **请求函数**
 *
 * @分类 [群运营↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10866)
 * @请求头 `POST /wxGroup/top`
 * @更新时间 `2024-02-28 15:40:02`
 */
export const feimaChatWxGroupTop = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxGroupTopRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatWxGroupTopResponse, OT>>(
    '/wxGroup/top',
    'POST',
    data,
    options
  );

/**
 * 接口 [群成员列表↗](https://yapi.fenxianglife.com/project/379/interface/api/47803) 的 **请求函数**
 *
 * @分类 [群运营↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10866)
 * @请求头 `POST /wxGroup/member/list`
 * @更新时间 `2024-04-23 09:59:40`
 */
export const feimaChatWxGroupMemberList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxGroupMemberListRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatWxGroupMemberListResponse, OT>
  >('/wxGroup/member/list', 'POST', data, options);

/**
 * 接口 [删除群成员↗](https://yapi.fenxianglife.com/project/379/interface/api/47806) 的 **请求函数**
 *
 * @分类 [群运营↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10866)
 * @请求头 `POST /wxGroup/member/delete`
 * @更新时间 `2024-02-28 15:41:55`
 */
export const feimaChatWxGroupMemberDelete = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxGroupMemberDeleteRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatWxGroupMemberDeleteResponse, OT>
  >('/wxGroup/member/delete', 'POST', data, options);

/**
 * 接口 [获取用户踢人配置↗](https://yapi.fenxianglife.com/project/379/interface/api/47809) 的 **请求函数**
 *
 * @分类 [群运营↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10866)
 * @请求头 `POST /wxGroup/riskRuleInfo`
 * @更新时间 `2024-02-28 09:43:01`
 */
export const feimaChatWxGroupRiskRuleInfo = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatWxGroupRiskRuleInfoRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatWxGroupRiskRuleInfoResponse, OT>
  >('/wxGroup/riskRuleInfo', 'POST', data, options);

/**
 * 接口 [用户设置踢人配置↗](https://yapi.fenxianglife.com/project/379/interface/api/47812) 的 **请求函数**
 *
 * @分类 [群运营↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10866)
 * @请求头 `POST /wxGroup/configRiskRule`
 * @更新时间 `2024-02-28 09:43:01`
 */
export const feimaChatWxGroupConfigRiskRule = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxGroupConfigRiskRuleRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatWxGroupConfigRiskRuleResponse, OT>
  >('/wxGroup/configRiskRule', 'POST', data, options);

/**
 * 接口 [用户关键词配置↗](https://yapi.fenxianglife.com/project/379/interface/api/47815) 的 **请求函数**
 *
 * @分类 [群运营↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10866)
 * @请求头 `POST /wxGroup/configKeyWord`
 * @更新时间 `2024-02-28 14:22:00`
 */
export const feimaChatWxGroupConfigKeyWord = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxGroupConfigKeyWordRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatWxGroupConfigKeyWordResponse, OT>
  >('/wxGroup/configKeyWord', 'POST', data, options);

/**
 * 接口 [用户关键词列表↗](https://yapi.fenxianglife.com/project/379/interface/api/47818) 的 **请求函数**
 *
 * @分类 [群运营↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10866)
 * @请求头 `POST /wxGroup/keyWordList`
 * @更新时间 `2024-02-28 14:22:00`
 */
export const feimaChatWxGroupKeyWordList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxGroupKeyWordListRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatWxGroupKeyWordListResponse, OT>
  >('/wxGroup/keyWordList', 'POST', data, options);

/**
 * 接口 [编辑关键词↗](https://yapi.fenxianglife.com/project/379/interface/api/47821) 的 **请求函数**
 *
 * @分类 [群运营↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10866)
 * @请求头 `POST /wxGroup/editKeyWord`
 * @更新时间 `2024-02-28 09:43:01`
 */
export const feimaChatWxGroupEditKeyWord = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxGroupEditKeyWordRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatWxGroupEditKeyWordResponse, OT>
  >('/wxGroup/editKeyWord', 'POST', data, options);

/**
 * 接口 [删除关键词↗](https://yapi.fenxianglife.com/project/379/interface/api/47824) 的 **请求函数**
 *
 * @分类 [群运营↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10866)
 * @请求头 `POST /wxGroup/delKeyWord`
 * @更新时间 `2024-02-28 09:43:01`
 */
export const feimaChatWxGroupDelKeyWord = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxGroupDelKeyWordRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatWxGroupDelKeyWordResponse, OT>
  >('/wxGroup/delKeyWord', 'POST', data, options);

/**
 * 接口 [微信群聊同步↗](https://yapi.fenxianglife.com/project/379/interface/api/51288) 的 **请求函数**
 *
 * @分类 [群运营↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10866)
 * @请求头 `POST /wxGroup/group/sync`
 * @更新时间 `2024-05-17 11:02:28`
 */
export const feimaChatWxGroupGroupSync = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxGroupGroupSyncRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatWxGroupGroupSyncResponse, OT>>(
    '/wxGroup/group/sync',
    'POST',
    data,
    options
  );

/* prettier-ignore-end */
